import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import logo from "../../public/assets/images/logo1.png"

import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
const headerVariants = {
  hidden: { y: -100, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 1.2,
      ease: 'easeOut',
      when: 'beforeChildren',
      staggerChildren: 0.3
    }
  }
};

const logoVariants = {
  hidden: { rotate: 0, opacity: 0 },
  visible: {
    rotate: 360,
    opacity: 1,
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};

const textVariants = {
  hidden: { x: -50, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hoveredNav, setHoveredNav] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const navLists = [
    {
      name: "Invest with Us",
      path: "/invest-with-us",
      submenu: [
        { name: "Our Process", path: "/our-process" },
        { name: "Recent-properties", path: "/recent-properties" },
        { name: "Reviews", path: "/reviews" },
        { name: "FAQs", path: "/faqs" },
      ]
    },
    {
      name: "About",
      path: "/about"
    },
    {
      name: "Careers",
      path: "/careers"
    },
  ];
  const navListsMobile = [
    {
      name: "About",
      path: "/about"
    },
    {
      name: "Invest with Us",
      path: "/invest-with-us",
    },
    { 
      name: "Our Process",
      path: "/our-process" 
    },

    {
      name: "Recent-properties", 
      path: "/recent-properties"
    },

    { 
      name: "Reviews",
      path: "/reviews" 
    },

    { 
      name: "FAQs",
      path: "/faqs" 
    },

    {
      name: "Careers",
      path: "/careers"
    },
    {
      name: "Contact",
      path: "/contact"
    },
  ];

  return (
    <AnimatePresence mode="wait">
      <motion.header
        key={location.pathname}
        variants={headerVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        className="fixed top-0 left-0 w-full z-50 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white shadow-lg"
      >
        <nav className="flex items-center justify-between px-5 sm:px-10 py-1 screen-max-width">
         {/* LOGO */}
          <a className="nav-link" href='/' onClick={() => setMenuOpen(false)}>
               <div className="flex items-center justify-center h-20 space-x-2">
            {/* Logo Icon */}
           <motion.div variants={logoVariants}>
               <div className='pulse-bright'>
             <img
          src={logo}
          alt="InvestorRise Icon"
          className="w-16 h-14"
          id="navbar-logo"
        />
      </div>
    </motion.div>

    {/* Text Content: Title + Slogan */}
    <div className="flex flex-col leading-tight">
      <div className="flex text-xl font-normal tracking-wide space-x-1">
        <motion.span
          initial={{ x: -30, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 1 }}
          className="text-white"
        >
          Investor
        </motion.span>

        <motion.span
          initial={{ x: -30, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 1.6 }}
          className="text-[#14b8a6] font-medium"
        >
          Rise
        </motion.span>
      </div>

      {/* Slogan Below Name */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 2.2 }}
      >
        <span className="text-xs sm:text-sm text-gray-200 tracking-wide">
          Invest Smarter • Rise Higher
        </span>
      </motion.div>
    </div>
  </div>
</a>


          {/* Desktop Nav */}
          <div className="hidden md:flex flex-1 justify-center gap-14 relative">
  {navLists.map((nav) => {
    const hasSubmenu = nav.submenu && nav.submenu.length > 0;
    const isHovered = hoveredNav === nav.name;

    return (
      <div
        key={nav.name}
        className="relative group"
        onMouseEnter={() => setHoveredNav(nav.name)}
        onMouseLeave={() => setHoveredNav(null)}
      >
        {/* Nav link with rotating arrow */}
        <div className="flex items-center gap-2 text-xl font-semibold text-slate-200 cursor-pointer hover:text-teal-400 transition duration-300">
          <a href={nav.path} className="flex items-center gap-1">
            {nav.name}
            {hasSubmenu && (
              <motion.span
                animate={{ rotate: isHovered ? 180 : 0 }}
                transition={{ duration: 0.3 }}
                className="text-sm"
              >
                <FaChevronDown />
              </motion.span>
            )}
          </a>
        </div>

        {/* Dropdown menu */}
        <AnimatePresence>
          {hasSubmenu && isHovered && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              className="absolute top-full left-0 mt-3 w-56 bg-slate-800 rounded-lg shadow-xl z-50 py-2"
              onMouseEnter={() => setHoveredNav(nav.name)}
              onMouseLeave={() => setHoveredNav(null)}
            >
              {nav.submenu.map((item) => (
                <a
                  key={item.name}
                  href={item.path}
                  className="block px-4 py-3 text-white hover:bg-teal-600 transition duration-200"
                >
                  {item.name}
                </a>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  })}
</div>



          {/* Contact Us */}
     <div className="hidden md:flex">
            <Link to='/contact' className="nav-link">
            <button className="relative inline-block px-4 py-2 text-xl font-semibold text-white bg-teal-500  overflow-hidden group">
            <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 transition-all duration-500 ease-in-out group-hover:w-full group-hover:left-0 animate-slide-bg"></span>
            <span className="relative z-10 group-hover:text-white transition-colors duration-300">
              Contact
            </span>
              </button>

            </Link>
          </div>





          <div className="md:hidden px-4 py-3 flex justify-between items-center  text-white">
      {/* <Link to="/" className="text-2xl font-bold">Logo</Link> */}

      <button onClick={toggleMenu} className="text-2xl">
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            transition={{ duration: 0.5 }}
            exit={{ height: 0, opacity: 0 }}
            className="absolute top-full left-0 w-full bg-slate-800 z-50 shadow-lg rounded-b-lg overflow-hidden"
          >
            <div className="flex flex-col p-4 space-y-2">
              {navListsMobile.map((nav) => {
                const hasSubmenu = nav.submenu && nav.submenu.length > 0;
                const isOpen = openSubmenu === nav.name;

                return (
                  <div key={nav.name}>
                    <button
                      onClick={() =>
                        hasSubmenu
                          ? setOpenSubmenu(isOpen ? null : nav.name)
                          : setMenuOpen(false)
                      }
                      className="w-full flex justify-between items-center px-3 py-2 text-lg font-medium text-left bg-slate-700 hover:bg-teal-600 rounded-md transition"
                    >
                      <a href={nav.path} className="w-full text-left">{nav.name}</a>
                      {hasSubmenu && (
                        <motion.span
                          animate={{ rotate: isOpen ? z80 : 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <FaChevronDown />
                        </motion.span>
                      )}
                    </button>

                    {/* Submenu */}
                    
                  </div>
                );
              })}

             
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>





        
        </nav>
      </motion.header>
    </AnimatePresence>
  );
}
